export default __webpack_public_path__ + "static/media/reeses-image.4ee85648.png";